/**
 * Correzione della deriva in modalità sincronizzata (funzione pura).
 *   |err| > 500 ms  -> seek
 *   |err| > 40 ms   -> playbackRate in [0.97, 1.03] proporzionale all'errore
 *   |err| <= 15 ms  -> rate 1
 *   in mezzo        -> si tiene il rate corrente (isteresi, evita oscillazioni)
 * `errMs` = posizione reale - posizione attesa (positivo = il video è in anticipo).
 */
export const SEEK_THRESHOLD_MS = 500;
export const RATE_THRESHOLD_MS = 40;
export const SETTLED_MS = 15;
export const MAX_RATE_DELTA = 0.03;

export type DriftAction = { action: 'none' | 'rate' | 'seek'; rate: number };

export function driftCorrection(errMs: number, currentRate: number, seekThresholdMs = SEEK_THRESHOLD_MS): DriftAction {
  const abs = Math.abs(errMs);
  if (abs > seekThresholdMs) return { action: 'seek', rate: 1 };
  if (abs > RATE_THRESHOLD_MS) {
    const delta = Math.max(-MAX_RATE_DELTA, Math.min(MAX_RATE_DELTA, errMs / 2000));
    const rate = Math.round((1 - delta) * 1000) / 1000;
    return rate === currentRate ? { action: 'none', rate } : { action: 'rate', rate };
  }
  if (abs <= SETTLED_MS && currentRate !== 1) return { action: 'rate', rate: 1 };
  return { action: 'none', rate: currentRate };
}
